const paymentInfo = {
    namespaced: true,
    state : {
        paymentList : [],
        virtualAccountInfo: null,
    },
    getters: {
        getPaymentList (state) {
            return state.paymentList
        },
        getVirtualAccountInfo (state) {
            return state.virtualAccountInfo
        },
    },
    mutations: {
        setPaymentList (state, payload) {
            state.paymentList = payload
        },
        setVirtualAccountInfo (state, payload) {
            state.virtualAccountInfo = payload
        },
    },
    actions: {
        setPaymentList ({commit}, payload) {
            commit('setPaymentList', payload)
        },
        setVirtualAccountInfo ({commit}, payload) {
            commit('setVirtualAccountInfo', payload)
        },
    }
}

export default paymentInfo